module.exports = __webpack_public_path__ + "img/404.982e848a.svg";